import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';

import {nwToast} from '../../../state/workspaces/namedWorkspaceToast';
import {PanelCopyLinkMenuItem} from '../common/PanelCopyLinkMenuItem';
import {usePanelContext} from '../PanelContextProvider';

/**
 * Since we're already on the full screen panel page, we can just directly copy
 * the curren URL.
 */
export const FullScreenPanelCopyLinkMenuItem = () => {
  const {trackPanelControls} = usePanelContext();

  const onSelect = useCallback(() => {
    copyToClipboard(window.location.href);
    nwToast('Copied to clipboard');

    trackPanelControls({action: 'Panel link copied'});
  }, [trackPanelControls]);

  return <PanelCopyLinkMenuItem onSelect={onSelect} />;
};
